import React from 'react';
import { FiEdit } from 'react-icons/fi';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import Anchor from '../../../../../components/link/Anchor';
import { TAG_GROUP_EDIT_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { TAG_GROUP_TYPE_TEXT } from '../../../../../constants/service/app/tagConstants';
import { reDirectPage, setDetailPageUrl, setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  태그 그룹 리스트 컬림
 */
export const columns = (data) => {
  const { sortOption } = data;

  return [
    {
      title: <TableColumnTitle title={'수정'} />,
      dataIndex: 'edit',
      render: (value, record) => (
        <FiEdit
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(TAG_GROUP_EDIT_URL_PATH, record.id),
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'태그 그룹 ID'} />,
      dataIndex: 'id',
      render: (value) => (
        <Anchor
          text={value}
          isUnderLine
          color="primary"
          href={setDetailPageUrl(TAG_GROUP_EDIT_URL_PATH, value)}
          target="_blank"
        />
      ),
    },
    {
      title: <TableColumnTitle title={'태그 그룹명'} />,
      dataIndex: 'name',
    },
    {
      title: <TableColumnTitle title={'태그 그룹 타입'} />,
      dataIndex: 'type',
      render: (value) => TAG_GROUP_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'연결된 태그 수'} />,
      dataIndex: 'tagGroupItemCount',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'tagGroupCreateDate',
      sorter: true,
      sortOrder: sortOption['tagGroupCreateDate'],
      render: (value) => setDateFormat(value),
    },
  ];
};
